import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getQueryString } from 'src/app/shared/utils/misc.util';

@Injectable({
  providedIn: 'root'
})
export class CartolaService {
  API_URL = environment.apiGatewayURL;

  constructor(private http: HttpClient) {}

  getSaldoCliente(usuarioId: string): Promise<{saldo: number, lineaCreditoId: number | undefined, balancePermitido: number, lineaBloqueada: boolean | undefined, sobregiro: number | undefined}>{
    const serviceURL = `${this.API_URL}saldo/${usuarioId}`;
    return firstValueFrom(this.http.get<{saldo: number, lineaCreditoId: number | undefined, balancePermitido: number, lineaBloqueada: boolean | undefined, sobregiro: number | undefined}>(serviceURL));
  }
  getTransaccionesCliente(usuarioId: string): Promise<any[]>{
    const serviceURL = `${this.API_URL}depositos/${usuarioId}`;
    return firstValueFrom(this.http.get<any[]>(serviceURL));
  }

  getTransaccionesRezagadas(query: any, currentPage: number, pageSize: number): Promise<any>{
    const queryString = getQueryString(query);
    const serviceURL = `${this.API_URL}unassigned-transaction?${queryString}&page=${currentPage}&pageSize=${pageSize}`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  getBillingRecords(params: {
    startDate: string;
    endDate: string;
    rutEmisor: string;
    rut_origen?: string;
    email?: string;
    numero_id?: string;
    page?: number;
    limit?: number;
  }): Promise<{ items: any[]; total: number }> {
    let httpParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('rutEmisor', params.rutEmisor);

    if (params.rut_origen) httpParams = httpParams.set('rut_origen', params.rut_origen);
    if (params.email) httpParams = httpParams.set('email', params.email);
    if (params.numero_id) httpParams = httpParams.set('numero_id', params.numero_id);
    if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString());
    if (params.limit !== undefined) httpParams = httpParams.set('limit', params.limit.toString());

    return firstValueFrom(
      this.http.get<{ items: any[]; total: number }>(
        `${this.API_URL}transaccion/billing-record`,
        { params: httpParams }
      )
    );
  }

  getEmisores(): Promise<any[]>{
    const serviceURL = `${this.API_URL}general-types/emisores`;
    return firstValueFrom(this.http.get<any[]>(serviceURL));
  }

  setEstadoEmisor(id: number, status: boolean): any{
    const serviceURL = `${this.API_URL}general-types/emisores`;
    return firstValueFrom(this.http.post<any[]>(serviceURL, {id: id, status: status}));
  }
}
